import { useLocale, useTranslations } from 'next-intl'

import { THost } from '@/entities/room'
import { CertifiedBadge, EnglishCertifiedBadge, Profile } from '@/entities/user'

export const UserInformation = ({
  picProfile,
  name,
  isCertificated,
  introduction,
}: THost) => {
  const locale = useLocale()
  const t = useTranslations('room_detail')

  const Badge = locale === 'en' ? EnglishCertifiedBadge : CertifiedBadge

  return (
    <div>
      <div className="mb-3 flex items-center gap-3">
        <Profile
          src={picProfile}
          alt={t('landlord_profile.profile_image', { name })}
          size={60}
        />

        <div className="flex flex-col gap-2">
          <span className="typo-body1 font-semibold text-gray-900">{name}</span>
          {isCertificated && <Badge />}
        </div>
      </div>

      <p className="typo-label1-reading min-h-[66px] w-60 font-normal whitespace-break-spaces text-gray-600">
        {introduction}
      </p>
    </div>
  )
}
